import React, {useState, useEffect, useCallback}  from 'react'
import ReactEcharts from "echarts-for-react";
import {Form, Button, Select, DatePicker, message, Empty,} from 'antd';
import {reqOrderAnalysis, baseUrl} from '../../api'
import moment from 'moment';
import 'moment/locale/zh-cn';
import SelectFormItem from '../../components/select-form-item'
const {RangePicker} = DatePicker;
const {Option} = Select;

function Order(props) {
    const [average, setAverage] = useState(0);
    const [dates, setDates] = useState([]);
    const [items, setItems] = useState([]);
    const [optTypeFrom, setOptTypeFrom] = useState('collect');
    const [optTypeTo, setOptTypeTo] = useState('');
    useEffect(() => {
        if (props.deliveryType != null) {
            initData();
        }
    }, [props.deliveryType]);
    const initData = async () => {
        const orderTimeliness = JSON.parse(sessionStorage.getItem("orderTimeliness" + props.deliveryType));
        if (orderTimeliness != null) {
            if (orderTimeliness.optTypeFrom) {
                await setOptTypeFrom(orderTimeliness.optTypeFrom);
            }
            if (orderTimeliness.optTypeTo) {
                await setOptTypeTo(orderTimeliness.optTypeTo);
            }
            const date = [];
            if (orderTimeliness.dateFrom) {
                date.push(moment(orderTimeliness.dateFrom, 'YYYY-MM-DD HH:mm:ss'));
                date.push(moment(orderTimeliness.dateTo, 'YYYY-MM-DD HH:mm:ss'));
                orderTimeliness.date = date;
            }
            const endDate = [];
            if (orderTimeliness.endDateFrom) {
                endDate.push(moment(orderTimeliness.endDateFrom, 'YYYY-MM-DD HH:mm:ss'));
                endDate.push(moment(orderTimeliness.endDateTo, 'YYYY-MM-DD HH:mm:ss'));
                orderTimeliness.endDate = endDate;
            }
            await props.form.setFieldsValue(orderTimeliness);
        } else {
            await props.form.setFieldsValue({
                entId: '',
                optTypeFrom: 'collect',
                originCity: '',
                optTypeTo: 'arrive',
                destinationCity: '',
                date: [moment(new Date(), "YYYY-MM-DD").subtract(29, 'days'), moment(new Date(), "YYYY-MM-DD")],
                endDate: null,
                topNum: '',
            });
        }
        getProductsByValues();
    }
    const handleOptTypeFrom = (value) => {
        setOptTypeFrom(value);
    }
    const handleOptTypeTo = (value) => {
        setOptTypeTo(value);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        getProductsByValues();
    };
    const getProductsByValues = () => {
        props.form.validateFields((err, values) => {
            if (!err) {
                for (let key of  Object.keys(values)) {
                    if (values[key] != null) {
                        if (key === 'date' || key === 'endDate') {
                            if (values[key].length > 0) {
                                let dateFrom = values[key][0].format('YYYY-MM-DD');
                                let dateTo = values[key][1].format('YYYY-MM-DD');
                                values[key + 'From'] = dateFrom + ' 00:00:00';
                                values[key + 'To'] = dateTo + ' 23:59:59';
                                delete values[key];
                            }
                        } else {
                            continue;
                        }
                    }
                }
                values.deliveryType = props.deliveryType;
                sessionStorage.setItem('orderTimeliness' + props.deliveryType, JSON.stringify(values));
                getAnalysis(values);
            }
        });
    };
    const getAnalysis = async (po) => {
        let result = await reqOrderAnalysis(po);
        if (result.code === 200) {
            const dateArray = [];
            const itemArray = [];
            result.data.data.map(o => {
                dateArray.push(o.id + '/' + o.orderNo);
                itemArray.push(o.timeliness);
            });
            setAverage(result.data.average);
            setDates(dateArray);
            setItems(itemArray);
        } else {
            message.error(result.message)
        }
    };
    const handleExport = () => {
        const searchData = props.form.getFieldsValue();
        if (checkDate(searchData.date) && checkDate(searchData.endDate)) {
            message.error('起始时间或截至时间必须填写一个');
            return
        }
        const search = [];
        for (let key of  Object.keys(searchData)) {
            if (searchData[key] != null) {
                if (key === 'date' || key === 'endDate') {
                    if (searchData[key].length > 0) {
                        let dateFrom = searchData[key][0].format('YYYY-MM-DD');
                        let dateTo = searchData[key][1].format('YYYY-MM-DD');
                        search.push('&' + key + 'From=' + dateFrom + ' 00:00:00');
                        search.push('&' + key + 'To=' + dateTo + ' 23:59:59');
                    }
                } else {
                    search.push('&' + key + '=' + searchData[key])
                }
            }
        }
        search.push('&deliveryType=' + props.deliveryType);
        let url = baseUrl + "/api/v1/p/analysis/export?" + search.join('');
        window.open(url, "_blank");
    };
    const checkDate = (date) => {
        return date == null || (date != null && date.length == 0)
    }
    const clickEcharts = (e) => {
        const searchData = props.form.getFieldsValue();
        for (let key of  Object.keys(searchData)) {
            if (searchData[key] != null) {
                if (key === 'date' || key === 'endDate') {
                    if (searchData[key].length > 0) {
                        let dateFrom = searchData[key][0].format('YYYY-MM-DD');
                        let dateTo = searchData[key][1].format('YYYY-MM-DD');
                        searchData[key + 'From'] = dateFrom + ' 00:00:00';
                        searchData[key + 'To'] = dateTo + ' 23:59:59';
                        delete searchData[key];
                    }
                }
            }
        }
        props.history.push('/TrackDetail', {orderId: e.name.split('/')[0],});
    };
    const option = {
        title: {
            show: items.length !== 0,
            text: props.deliveryType === 'N' ? '订单时效分析图 (总计:' + items.length + ')' : 'TIR订单时效分析图 (总计:' + items.length + ')',
        },
        grid: {
            left: 20,
            right: 50,
            top: 50,
            //  bottom: (items.length > 25 ? 35 : 20),
            bottom: 20,
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            data: dates,
            axisLabel: {
                interval: 0,
                // rotate: this.state.rotateX,
                formatter: function (value, index) {
                    return ''
                }
            }
        },
        yAxis: {},
        /* dataZoom: [{
         show: (items.length > 25),
         showDetail: false,
         end: 2500 / (items.length),
         }],*/
        color: ['#0B8DEB'],
        series: [{
            type: 'bar',
            data: items,
            label: {
                show: (items.length > 40 ? false : true),
            },
            markPoint: {
                data: [
                    {type: 'max', name: '最大值', itemStyle: {color: "rgba(217, 50, 50, 1)"},},
                    {type: 'min', name: '最小值', itemStyle: {color: "rgba(57, 191, 16, 1)"},}
                ],
                silent: true,//不响应和出发鼠标事件
            },
            markLine: {
                data: [{
                    //type: "average"
                    yAxis: average,
                }],
                silent: true,//不响应和出发鼠标事件
            },
        }],
    };
    const {getFieldDecorator} = props.form;
    const optTypeOptions = (props.optTypes || []).map(o => {
        return <Option key={o.code} value={o.code}>{o.name}</Option>
    });
    const entOptions = (props.ents || []).map(o => {
        return <Option key={o.entId} value={o.entId}>{o.entName}</Option>
    });
    return <div className="echarts-information">
        <div className="echarts-information-title">
            <Form layout='inline' onSubmit={handleSubmit}>
                <Form.Item label="">
                    {getFieldDecorator('entId', {
                        initialValue: '',
                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode} style={{width: '150px'}}>
                        <Option value="">全部客户</Option>
                        {entOptions}
                    </Select>)}
                </Form.Item>
                <Form.Item label="区域">
                    {getFieldDecorator('optTypeFrom', {
                        initialValue: 'collect',
                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode} style={{width: '150px'}}
                               onChange={handleOptTypeFrom}>
                        {optTypeOptions}
                    </Select>)}
                </Form.Item>
                {optTypeFrom === 'collect' ? <SelectFormItem
                    label='出发地'
                    name="originCity"
                    getFieldDecorator={getFieldDecorator}
                    data={props.areaF}
                    dataKey='cityId'
                    dataValue='cityName'
                    dataContent='countryName'
                    dataContent2='cityName'
                    style={{width: '150px'}}
                /> : null}
                {optTypeFrom === 'tir' ? <SelectFormItem
                    label='清关地'
                    name="customsClearanceCity"
                    getFieldDecorator={getFieldDecorator}
                    data={props.areaC}
                    dataKey='cityId'
                    dataValue='cityName'
                    dataContent='countryName'
                    dataContent2='cityName'
                    style={{width: '150px'}}
                /> : null}
                <Form.Item label="至">
                    {getFieldDecorator('optTypeTo', {
                        initialValue: 'arrive',
                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode} style={{width: '150px'}}
                               onChange={handleOptTypeTo}>
                        {optTypeOptions}
                    </Select>)}
                </Form.Item>
                {optTypeTo === 'destination' ? <SelectFormItem
                    label='目的地'
                    name="destinationCity"
                    getFieldDecorator={getFieldDecorator}
                    data={props.areaT}
                    dataKey='cityId'
                    dataValue='cityName'
                    dataContent='countryName'
                    dataContent2='cityName'
                    style={{width: '200px'}}
                /> : null}
                {optTypeTo === 'tir' ? <SelectFormItem
                    label='清关地'
                    name="customsClearanceCity"
                    getFieldDecorator={getFieldDecorator}
                    data={props.areaC}
                    dataKey='cityId'
                    dataValue='cityName'
                    dataContent='countryName'
                    dataContent2='cityName'
                    style={{width: '150px'}}
                /> : null}
                <Form.Item label="开始时间">
                    {getFieldDecorator('date', {
                        initialValue: [moment(new Date(), "YYYY-MM-DD").subtract(29, 'days'), moment(new Date(), "YYYY-MM-DD")]
                    })(<RangePicker format="YYYY-MM-DD" style={{width: '250px'}}/>)}
                </Form.Item>
                <Form.Item label="截止时间">
                    {getFieldDecorator('endDate', {})(<RangePicker format="YYYY-MM-DD" style={{width: '250px'}}/>)}
                </Form.Item>
                <Form.Item label="时效">
                    {getFieldDecorator('topNum', {
                        initialValue: '',
                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode} style={{width: '100px'}}>
                        <Option value="">全部</Option>
                        <Option value="20">最短20</Option>
                        <Option value="30">最短30</Option>
                        <Option value="50">最短50</Option>
                    </Select>)}
                </Form.Item>
                <Form.Item>
                    <Button className='margin-btn' type='primary' htmlType="submit">查询</Button>
                    <Button htmlType="button" onClick={handleExport}>导出</Button>
                </Form.Item>
            </Form>
        </div>
        <div className="echarts-information-content">
            {items.length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/> : <ReactEcharts
                option={option}
                style={{height: '250px', width: '100%'}}
                className='react_for_echarts'
                onEvents={{'click': clickEcharts,}}/>
            }
        </div>
    </div>

}
const OrderForm = Form.create()(Order);
export default OrderForm;
